import { IMAGE_MIME_TYPES } from 'pages/Batch/configs';

import pluggableApisService from 'services/pluggableApis';

import type { IProcessResult } from './toolchain';

const removeBgProcess = async (itemKey: string, isCancel: () => boolean): Promise<IProcessResult> => {
  const imageUrl = await pluggableApisService.backgroundRemove(itemKey, isCancel);

  return new Promise(resolve => {
    resolve({ result: imageUrl, type: IMAGE_MIME_TYPES.WEBP });
  });
};

export default removeBgProcess;
